<template>
  <div class="settings-sidemenu">
    <div class="submenu-section">
      <GekkoButton 
        :text="$gettext('Back to Gekko')"
        :href="Urls['gekko_dashboard']()"
        icon="fa-solid fa-arrow-left"
        class="w-100"
      />
    </div>

    <!-- Admin -->
    <div v-if="is_staff" class="submenu-section">
      <ul class="submenu">
        <li class="nav-item">
          <a href="/tokeh"><font-awesome-icon icon="fa-solid fa-gears" /><span v-translate>Go to admin</span></a>
        </li>
      </ul>
    </div>

    <!-- Accountant settings -->
    <div v-show="currentUser.is_accountant && !currentCompany.has_accountant" :class="(currentUser.is_accountant && currentCompany.has_accountant)? 'submenu-section' : ''">
      <h4 class="submenu-title" v-translate>Account</h4>
      <ul class="submenu">
        <li class="nav-item first" :class="currentPage.includes(Urls['accounts_manage_companies']()) && 'active'">
          <router-link :to="Urls['accounts_manage_companies']()">
            <font-awesome-icon icon="fa-solid fa-briefcase" />
            <span v-translate>Company details</span>
          </router-link>
        </li>
        <li class="nav-item" :class="currentPage.includes(Urls['accounts_edit_profile']()) && 'active'">
          <router-link :to="Urls['accounts_edit_profile']()">
            <font-awesome-icon icon="fa-solid fa-cog" />
            <span v-translate>Personal profile</span>
          </router-link>
        </li>
        <li class="nav-item" :class="currentPage.includes(Urls['accounts_change_password']()) && 'active'">
          <router-link :to="Urls['accounts_change_password']()">
            <font-awesome-icon icon="fa-solid fa-lock" />
            <span v-translate>Change password</span>
          </router-link>
        </li>
      </ul>
    </div>

    <!-- Regular user settings -->
    <div v-show="!currentUser.is_accountant" class="submenu-section">
      <h4 class="submenu-title" v-translate>Account</h4>
      <ul class="submenu">
        <li class="nav-item first" :class="currentPage.includes(Urls['accounts_edit_profile']()) && 'active'">
          <router-link :to="Urls['accounts_edit_profile']()"><font-awesome-icon icon="fa-solid fa-cog" /><span v-translate>My profile</span></router-link>
        </li>
        <li class="nav-item last webapp-hide-disabled" :class="currentPage.includes(Urls['subscriptions:manage']()) && 'active'">
          <router-link :to="Urls['subscriptions:manage']()"><font-awesome-icon icon="fa-solid fa-eur" /><span v-translate>Subscriptions</span></router-link>
        </li>
        <li class="nav-item" :class="(currentPage.includes(Urls['accounts_team_settings']()) || currentPage.includes(Urls['accounts_team_settings']())) && 'active'">
          <router-link :to="{ name: 'Team' }"><font-awesome-icon icon="fa-solid fa-users" /><span v-translate>Team</span></router-link>
        </li>
        <li class="nav-item" :class="currentPage.includes(Urls['accounts_notification_settings']()) && 'active'">
          <router-link :to="Urls['accounts_notification_settings']()"><font-awesome-icon icon="fa-solid fa-bells" /><span v-translate>Notifications</span></router-link>
        </li>
      </ul>
    </div>

    <!-- Invoice settings -->
    <div v-show="showCompanySettings" class="submenu-section">
      <h4 class="submenu-title">
        {{ $gettext('Invoices') }}
      </h4>
      <ul class="submenu">
        <li class="nav-item" :class="(currentPage === Urls['accounts_invoice_settings']()) && 'active'">
          <router-link :to="Urls['accounts_invoice_settings']()"><font-awesome-icon icon="fa-solid fa-file" /><span v-translate>Invoice settings</span></router-link>
        </li>
        <li v-if="currentCompany.country == 'ES'" class="nav-item" :class="(currentPage === Urls['accounts_verifactu_settings']()) && 'active'">
          <router-link :to="Urls['accounts_verifactu_settings']()" class="verifactu-link">

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150"
              :class="currentPage === Urls['accounts_verifactu_settings']() ? 'aeat-logo-active' : 'aeat-logo'"
              fill="currentColor"
              style="height: 20px; width: 20px;">
              <path d="M0 0h150v150H0V0z" fill="none"/><path d="M141.9 130.2L76.1 17.8H22.8l66.7 112.4z"/>
              <path d="M23.3 121.4l6.5 10.1c57.8-3.3 104.2-50.6 108.6-83.7l-7.3-9.1c-9.4 45.1-67.5 80-107.8 82.7z"/>
              <path d="M38.9 59.1L44.3 70c-6.4 5.9-9.5 9.9-14 17.3-6 10-8.4 16.5-10.3 28l-8-13c2.6-8.3 4.7-12.9 9-20.5 5.7-9.6 9.8-14.8 17.9-22.7z"/>
            </svg>

            <span v-translate>Verifactu</span></router-link>
        </li>
        <li class="nav-item" :class="(currentPage === Urls['accounts_brands_settings']()) && 'active'">
          <router-link :to="Urls['accounts_brands_settings']()">
            <div style="display: flex; align-items: center; gap: 0.5rem;">
              <div>
                <font-awesome-icon icon="fa-solid fa-palette" />
                <span v-translate>Invoice design</span>
              </div>
            </div>
          </router-link>
        </li>
        <!--
        <li class="nav-item" :class="(currentPage === Urls['accounts_layout_builder']()) && 'active'">
          <router-link :to="Urls['accounts_layout_builder']()">
            <div style="display: flex; align-items: center; gap: 0.5rem;">
              <div>
                <font-awesome-icon icon="fa-solid fa-palette" />
                <span v-translate>Layout builder</span>
              </div>
              <GkBadge
                :text="$gettext('NEW')"
                variant="brand"
              />
            </div>
          </router-link>
        </li>
        -->
      </ul>
    </div>

    <!-- Company settings -->
    <div v-show="showCompanySettings" class="submenu-section">
      <h4 class="submenu-title company-title" v-translate>Company</h4>
      <ul class="submenu company-settings">
        <li class="nav-item" :class="currentPage.includes(Urls['accounts_manage_companies']()) && 'active'">
          <router-link :to="Urls['accounts_manage_companies']()"><font-awesome-icon icon="fa-solid fa-briefcase" /><span v-translate>Company details</span></router-link>
        </li>
        <!--
        <li class="nav-item" :class="currentPage.includes(Urls['accounts_bank_settings']()) && 'active'">
          <router-link :to="Urls['accounts_bank_settings']()"><font-awesome-icon icon="fa-solid fa-bank" /><span v-translate>Bank Settings</span></router-link>
        </li>
        -->
        <li class="nav-item webapp-hide-disabled" :class="currentPage.includes(Urls['products:home']()) && 'active'">
          <router-link :to="Urls['products:home']()"><font-awesome-icon icon="fa-solid fa-basket-shopping" /><span v-translate>Products</span></router-link>
        </li>
        <li class="nav-item" :class="currentPage.includes(Urls['accounts_costtypes_settings']()) && 'active'">
          <router-link :to="Urls['accounts_costtypes_settings']()"><font-awesome-icon icon="fa-solid fa-cart-shopping" /><span v-translate>Cost categories</span></router-link>
        </li>
        <li class="nav-item" :class="currentPage.includes(Urls['accounts_cars_settings']()) && 'active'">
          <router-link :to="Urls['accounts_cars_settings']()"><font-awesome-icon icon="fa-solid fa-truck" /><span v-translate>Cars</span></router-link>
        </li>
        <li class="nav-item" :class="currentPage.includes(Urls['accounts_import_data_settings']()) && 'active'">
          <router-link :to="Urls['accounts_import_data_settings']()" data-analytics-click="import data"><font-awesome-icon icon="fa-solid fa-upload" /><span v-translate>Import data</span></router-link>
        </li>
        <li class="nav-item" :class="currentPage.includes(Urls['accounts_download_data_settings']()) && 'active'">
          <router-link :to="Urls['accounts_download_data_settings']()"><font-awesome-icon icon="fa-solid fa-file" /><span v-translate>Download data</span></router-link>
        </li>
        <li class="nav-item" :class="currentPage.includes(Urls['accounts_ideal_payment_settings']()) && 'active'">
          <router-link :to="Urls['accounts_ideal_payment_settings']()"><font-awesome-icon icon="fa-regular fa-credit-card" /><span v-translate>iDEAL Payment</span></router-link>
        </li>
        <!--<li class="nav-item{% if active == 'bank_connection' %} active{% endif %}">
            <a href="{% url 'accounts_bank_connection' %}"><font-awesome-icon icon="fa-regular fa-credit-card" />{% trans 'Bank connection' %}</a>
        </li>-->
        <li class="nav-item" :class="currentPage.includes(Urls['accounts_webshop_settings']()) && 'active'">
          <router-link :to="Urls['accounts_webshop_settings']()"><font-awesome-icon icon="fa-solid fa-earth-americas" /><span v-translate>Webshop</span></router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

import GekkoButton from "@/components/GekkoButton"

export default {
  name: "SettingsSidemenu",
  components: {
    GekkoButton
  },
  data () {
    return {
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "main/getCurrentUser",
      currentCompany: "main/getCurrentCompany",
      currentUserRights: "main/getCurrentRights",
      is_staff: "main/getIsStaff",
    }),
    currentPage () {
      return this.$route.path;
    },
    showCompanySettings () {
      if (this.currentUser.is_accountant) {
        if (this.currentCompany.has_accountant) {
          return true;
        } else {
          return false;
        }
      }
      if (!this.currentUserRights.edit_company_profile) {
        return false;
      }
      return true;
    },
  },
  created () {
  },
};
</script>
<style lang="scss" scoped>
// @ settings_base.less
.settings-sidemenu {
  font-size: 1rem;
  .submenu {
    li {
      a {
        .svg-inline--fa { 
          margin-right: 0.5rem;
          width: 20px;
          opacity: 0.2;
        }
      }
      &.active a, a:hover {
        .svg-inline--fa { 
          opacity: 0.5;
        }
      }
    }
  }
}
.skeleton-element {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.verifactu-link {
  display: flex !important;
  align-items: center;
  gap: 8px;

  .aeat-logo {
    color: #ced4da;
  }

  .aeat-logo-active {
    color: #EB8D36;
  }
}

.verifactu-link:hover {
  .aeat-logo {
    color: #868b8f;
  }

  .aeat-logo-active {
    color: #f3ab68;
  }
}
</style>
